export default "__VITE_ASSET__f96ec479__"